export default {
      id: "color_immunity-usage",
      viewBox: "0 0 69 60",
      url: __webpack_public_path__ + "sprite.svg#color_immunity",
      toString: function () {
        return this.url;
      }
    }